import { useCases } from "@/mocks/home";

export default function UseCases() {
  return (
    <section className="py-20 md:py-28 bg-secondary-950 text-background-100 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 30%, oklch(var(--primary-500) / 0.4), transparent 40%), radial-gradient(circle at 80% 70%, oklch(var(--accent-500) / 0.4), transparent 40%)",
          }}
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="text-xs uppercase tracking-widest text-primary-400 font-semibold">Use cases</span>
            <h2 className="mt-3 text-3xl md:text-5xl font-semibold leading-tight">
              Whatever you&apos;re building with voice — we route it.
            </h2>
          </div>
          <p className="text-background-300 max-w-md text-sm md:text-base">
            Wholesale voice termination to 190+ countries with DTMF and fax support, plus 4 points of presence worldwide.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {useCases.map((u) => (
            <div
              key={u.title}
              className="rounded-xl bg-secondary-900/70 border border-secondary-800 p-6 hover:border-primary-500 transition-colors"
            >
              <span className="w-11 h-11 rounded-lg bg-primary-500/20 text-primary-400 flex items-center justify-center">
                <i className={`${u.icon} text-xl w-6 h-6 flex items-center justify-center`} />
              </span>
              <p className="mt-4 text-xs uppercase tracking-widest text-accent-400 font-medium">{u.tag}</p>
              <h3 className="mt-2 text-lg font-semibold font-heading text-background-50">{u.title}</h3>
              <p className="mt-2 text-sm text-background-300 leading-relaxed">{u.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}